import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Layout, Menu, Tag } from "antd";
import { IconLight } from "../icon_light";
import { Footer } from "../footer";
import AppIcon from "./appIcon.svg";

const SUBSCRIPTION_STATUS = {
  SUBSCRIBED: "SUBSCRIBED",
  BLOCKED: "BLOCKED",
  NOT_SUBSCRIBED: "NOT_SUBSCRIBED",
  TRIAL: "TRIAL"
};

class HeaderLeftSide extends Component {
  state = {
    location: this.props.location,
    financialHasAccess: this.props.financialHasAccess,
    physicalHasAccess: this.props.physicalHasAccess,
    sqlHasAccess: this.props.sqlHasAccess,
    performanceHasAccess: this.props.performanceHasAccess,
    accountEmail: this.props.accountEmail,
    isCollapsed: true,
    appsSubscription: this.props.appsSubscription
  };

  iconStyle = {
    marginRight: "8px"
  };

  onCollapseToggle = collapsed => {
    this.setState({
      isCollapsed: collapsed
    });
  };

  componentWillReceiveProps = newProps => {
    if (this.state.location !== newProps.location) {
      this.setState({ location: newProps.location });
    }
  };

  static getColorByStatus(status) {
    switch (status) {
      case SUBSCRIPTION_STATUS.SUBSCRIBED:
        return "green";
      case SUBSCRIPTION_STATUS.NOT_SUBSCRIBED:
        return "gray";
      case SUBSCRIPTION_STATUS.TRIAL:
        return "blue";
      case SUBSCRIPTION_STATUS.BLOCKED:
        return "red";
      default:
        return "black";
    }
  }

  render() {
    const {
      location,
      financialHasAccess,
      physicalHasAccess,
      sqlHasAccess,
      performanceHasAccess,
      accountEmail,
      isCollapsed,
      appsSubscription
    } = this.state;
    const menuSelectedKeys = [location.pathname];

    return (
      <Layout.Sider
        collapsible
        collapsed={isCollapsed}
        width={280}
        onCollapse={this.onCollapseToggle}
        style={{
          backgroundColor: "#143660",
          color: "#fff",
          borderRight: "1px solid #143660"
        }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            src={AppIcon}
            alt={"App logo"}
            style={{ maxWidth: "54px", padding: "8px" }}
          />

          <span>
            <h3
              style={{
                color: "#fff",
                lineHeight: "18px",
                fontWeight: "bold"
              }}
            >
              FCAS pays
            </h3>
          </span>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={menuSelectedKeys}
          style={{ backgroundColor: "#143660" }}
        >
          {financialHasAccess && (
            <Menu.Item key="/app/financial">
              <NavLink to="/app/financial">
                <IconLight
                  icon={"file-invoice-dollar"}
                  style={this.iconStyle}
                  className={"anticon"}
                />
                <span>Financial reports</span>
              </NavLink>
            </Menu.Item>
          )}
          {physicalHasAccess && (
            <Menu.Item key="/app/physical">
              <NavLink to="/app/physical">
                <IconLight
                  icon={"heart-rate"}
                  style={this.iconStyle}
                  className={"anticon"}
                />
                <span>Physical data</span>
              </NavLink>
            </Menu.Item>
          )}
          {/* Hidden from UI for now - 6/3/24 */}
          {performanceHasAccess && false && (
            <Menu.Item key="/app/performance">
              <NavLink to="/app/performance">
                <IconLight
                  icon={"tachometer"}
                  style={this.iconStyle}
                  className={"anticon"}
                />
                <span>Performance metric</span>
              </NavLink>
            </Menu.Item>
          )}

          <Menu.Item key="/app/info">
            <NavLink to="/app/info">
              <IconLight
                icon={"th-list"}
                className={"anticon"}
                style={this.iconStyle}
              />
              <span>Market information</span>
            </NavLink>
          </Menu.Item>
          {sqlHasAccess && (
            <Menu.Item key={"sql"}>
              <a
                href={"https://sql.fcaspays.com.au"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconLight
                  icon={"database"}
                  className={"anticon"}
                  style={this.iconStyle}
                />
                <span>SQL</span>
              </a>
            </Menu.Item>
          )}
          <Menu.SubMenu
            title={
              <span>
                <IconLight
                  icon={"info-circle"}
                  className={"anticon"}
                  style={this.iconStyle}
                />
                <span>Help</span>
              </span>
            }
          >
            {/*<Menu.Item key="help.tour">*/}
            {/*<a>*/}
            {/*<IconLight icon={"rocket"} style={this.iconStyle} />*/}
            {/*Start tour*/}
            {/*</a>*/}
            {/*</Menu.Item>*/}
            <Menu.Item key="help.docs">
              <a
                href="https://pdview.atlassian.net/wiki/spaces/FPKB/overview"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconLight icon={"info-circle"} style={this.iconStyle} />
                Help docs
              </a>
            </Menu.Item>
            {/*<Menu.Item key="help.videos">*/}
            {/*<a*/}
            {/*// href="https://www.youtube.com/watch?v=_EcGghRXYKM&list=PLuss093rSJjM-Aww9Jylw4AwHc5ePex5x"*/}
            {/*target="_blank"*/}
            {/*rel="noopener noreferrer"*/}
            {/*>*/}
            {/*<IconLight icon={"video"} style={this.iconStyle} />*/}
            {/*Help videos*/}
            {/*</a>*/}
            {/*</Menu.Item>*/}
            <Menu.Item key="help.contact">
              <a
                href="http://pdview.com.au/contact"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconLight icon={"comment"} style={this.iconStyle} />
                Contact us
              </a>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            title={
              <span>
                <IconLight
                  icon={"grip-horizontal"}
                  className={"anticon"}
                  style={this.iconStyle}
                />
                <span>Apps</span>
              </span>
            }
          >
            {appsSubscription &&
              Object.keys(appsSubscription) &&
              Object.keys(appsSubscription).map(i => [
                <Menu.Divider />,
                <Menu.ItemGroup key={i} title={<b>{i}</b>}>
                  {appsSubscription[i] &&
                    appsSubscription[i].map(a => (
                      <Menu.Item key={a.app_name}>
                        <a
                          href={a.app_url}
                          target={"_blank"}
                          title={a.subscription_status}
                        >
                          {a.app_name}
                          <Tag
                            style={{ marginLeft: "8px" }}
                            color={HeaderLeftSide.getColorByStatus(
                              a.subscription_status
                            )}
                          >
                            {a.subscription_status}
                          </Tag>
                        </a>
                      </Menu.Item>
                    ))}
                </Menu.ItemGroup>
              ])}
          </Menu.SubMenu>

          <Menu.SubMenu
            title={
              <span>
                <IconLight
                  icon={"user-circle"}
                  className={"anticon"}
                  style={this.iconStyle}
                />
                <span>Account</span>
              </span>
            }
          >
            <Menu.ItemGroup title={accountEmail}>
              <Menu.Item key="accountinfo">
                <a href={"https://apps.pdview.com.au/"}>
                  <IconLight icon={"user"} style={this.iconStyle} />
                  Account info
                </a>
              </Menu.Item>
              <Menu.Item key="logout">
                <NavLink to="/logout">
                  <IconLight icon={"sign-out"} style={this.iconStyle} />
                  Log out
                </NavLink>
              </Menu.Item>
            </Menu.ItemGroup>

            {/*<Menu.Item key="help.about">*/}
            {/*<a*/}
            {/*href="http://pdview.com.au/"*/}
            {/*target="_blank"*/}
            {/*rel="noopener noreferrer"*/}
            {/*>*/}
            {/*<FontAwesomeIcon icon={["fal", "info-square"]} /> About us*/}
            {/*</a>*/}
            {/*</Menu.Item>*/}
            {/*<Menu.Item key="help.terms">*/}
            {/*<a*/}
            {/*href="http://pdview.com.au/terms"*/}
            {/*target="_blank"*/}
            {/*rel="noopener noreferrer"*/}
            {/*>*/}
            {/*<FontAwesomeIcon icon={["fal", "file-contract"]} /> Terms of use*/}
            {/*</a>*/}
            {/*</Menu.Item>*/}

            {/*<Menu.Divider />*/}
            {/*<Menu.ItemGroup*/}
            {/*title={*/}
            {/*<AccountInfo*/}
            {/*email={accountEmail}*/}
            {/*status={accountStatus}*/}
            {/*daysLeft={accountDaysLeft}*/}
            {/*/>*/}
            {/*}*/}
            {/*/>*/}
          </Menu.SubMenu>
        </Menu>{" "}
        {!isCollapsed && (
          <Footer
            style={{
              color: "rgb(133, 145, 160)",
              padding: "8px",
              borderTop: "1px solid rgb(133, 145, 160)"
            }}
          />
        )}
      </Layout.Sider>
    );
  }
}

HeaderLeftSide.propTypes = {
  location: PropTypes.object.isRequired,
  physicalHasAccess: PropTypes.bool.isRequired,
  financialHasAccess: PropTypes.bool.isRequired,
  sqlHasAccess: PropTypes.bool.isRequired,
  performanceHasAccess: PropTypes.bool.isRequired,
  accountEmail: PropTypes.string.isRequired,
  accountStatus: PropTypes.string.isRequired,
  accountDaysLeft: PropTypes.number.isRequired,
  appsSubscription: PropTypes.object.isRequired
};

export default HeaderLeftSide;



// WEBPACK FOOTER //
// ./src/views/components/header/HeaderLeftSide.jsx